import React, { useState } from 'react'
import { TextAreaProps, WithTextAreaProps } from './interface'

export function withTextArea(Component: React.FC<TextAreaProps>) {
  function WithTextArea({
    value,
    maxLength,
    onChange,
    ...props
  }: WithTextAreaProps) {
    const [text, setText] = useState(value)

    function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
      const newValue = maxLength
        ? event.target.value.slice(0, maxLength)
        : event.target.value
      setText(newValue)

      if (onChange) {
        onChange(newValue)
      }
    }

    const componentProps = {
      ...props,
      value: text,
      maxLength,
      onChange: handleChange,
    }

    return <Component {...componentProps} />
  }

  return WithTextArea
}
